export default __webpack_public_path__ + "static/media/patreon.e6ee3d8b.svg";